<app-table
  (matSortChange)="onSortChange($event)"
  [showFilter]="false"
  matSort
  [scrollSize]="420"
>
  <ng-container matColumnDef="item">
    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 80px"
      >Numero de parte
    </mat-header-cell>
    <mat-cell *matCellDef="let element" style="min-width: 80px">
      <div class="tw-block">
        <p *ngIf="element.inventoryNumber" class="tw-font-bold tw-italic">
          LOT: {{ element.inventoryNumber }}
        </p>
        <p>{{ element.itemName }}</p>
      </div>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="quantityPerBatch">
    <mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      style="min-width: 80px"
      class="tw-flex tw-justify-center tw-items-center"
      >Cantidad Por Batch
    </mat-header-cell>
    <mat-cell
      *matCellDef="let element"
      style="min-width: 80px"
      class="tw-text-center tw-flex tw-justify-center tw-items-center"
    >
      {{ element.quantityPerBatch | number: ".2-3" }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="description">
    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 220px"
      >Descripcion
    </mat-header-cell>
    <mat-cell *matCellDef="let element" style="min-width: 220px">
      {{ element.itemDescription }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="quantity">
    <mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      style="min-width: 80px"
      class="tw-flex tw-justify-center tw-items-center"
      >Cantidad por numero de parte
    </mat-header-cell>
    <mat-cell
      *matCellDef="let element"
      style="min-width: 80px"
      class="tw-text-center tw-flex tw-justify-center tw-items-center"
    >
      {{ element.quantityPerAssembly | number: ".2-3" }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="onhand">
    <mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      style="min-width: 80px"
      class="tw-flex tw-justify-center tw-items-center"
      >On Hand
    </mat-header-cell>
    <mat-cell
      *matCellDef="let element"
      style="min-width: 80px"
      class="tw-text-center tw-flex tw-justify-center tw-items-center"
      >{{ element.quantityOnHand | number: ".2-3" }}
    </mat-cell>
  </ng-container><ng-container matColumnDef="unitType">
  <mat-header-cell
    *matHeaderCellDef
    mat-sort-header
    style="min-width: 80px"
    class="tw-flex tw-justify-center tw-items-center"
  >Unit Type
  </mat-header-cell>
  <mat-cell
    *matCellDef="let element"
    style="min-width: 80px"
    class="tw-text-center tw-flex tw-justify-center tw-items-center"
  >
    {{ element.unitType }}
  </mat-cell>
</ng-container>
  <ng-container matColumnDef="verified">
    <mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      style="min-width: 100px"
    ></mat-header-cell>
    <mat-cell *matCellDef="let element" style="min-width: 100px">
      <button
        (click)="validateBomLot(element)"
        *ngIf="element.showValidation && !element.verified"
        class="tw-bg-emerald-600 hover:tw-bg-emerald-500 tw-text-white"
        mat-icon-button
      >
        <mat-icon>verified</mat-icon>
      </button>
      <p *ngIf="element.showValidation && element.verified">
        Validado el {{ element.verified | date: "MM/dd/yyyy" }}
      </p>
    </mat-cell>
  </ng-container>
</app-table>
